var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"gray"},[_vm._v(_vm._s(_vm.myData.ismilestone))])]),_c('div',{staticClass:"row"},[_c('span',{staticClass:"gray"},[_vm._v(_vm._s(_vm.getNewTitle(`合同号${_vm.myData.pk_busicontract}`)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }